import React from "react";
import { connect } from "react-redux";
import { Button, Row, Col } from "reactstrap";
import { Field, reduxForm, FieldArray,formValueSelector } from "redux-form";
import "react-dropdown/style.css";
import { Card, CardHeader, CardBody } from 'reactstrap';
import renderSelectField from '../../../../shared/components/form/Select';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Please enter the Job Description name";
  }
  return errors;
};

const renderField =
  ({
     input, placeholder, type, meta: { touched, error },
   }) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <input {...input} placeholder={placeholder} type={type} />
      {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
  input: PropTypes.shape().isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

renderField.defaultProps = {
  placeholder: '',
  meta: null,
  type: 'text',
};

const filterAssetTypesOptionData = (dataObject) => {
  let filteredData = [];
  dataObject.filter(data => {
    filteredData.push({value : data._id, label: data.name});
    return data;
  });
  return filteredData;
};

const filterCollectionOptionData = (dataObject) => {
  let filteredData = [];
  dataObject.filter(data => {
    filteredData.push({value : data._id, label: data.collection_name});
    return data;
  });
  return filteredData;
};

const renderParam = ({ fields, meta: { error, submitFailed } }, t) => {
  return (
    <div>
      <Card>
        <CardHeader >
          <Row>
            <Col className="text-left">
              <i>{t('asset_management.create_update_asset.form_update_detail_title')}</i>
            </Col>
            <Col className="text-right">
              <Button onClick={() => fields.push({ key: "", value: "" })}>
                Add New Details Parameter
              </Button>
              {submitFailed && error && <span>{error}</span>}
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          {fields.map((param, index) => (
            <Row key={index}>
              <Col xs="12" sm="5" className="form form--horizontal" >
                <div className="form__form-group">
                  <div className="form__form-group-field">
                    <Field
                      name={`${param}.key`}
                      type="text"
                      component={renderField}
                      className="mb-0"
                    />
                  </div>
                </div>
              </Col>
              <Col xs="12" sm="5" className="form form--horizontal" >
                <div className="form__form-group">
                  <div className="form__form-group-field">
                    <Field
                      name={`${param}.value`}
                      type="text"
                      component={renderField}
                      className="mb-0"
                    />
                  </div>
                </div>
              </Col>
              <Button title="Remove Param" onClick={() => fields.remove(index)}>
                Remove Param
              </Button>
            </Row>
          ))}
        </CardBody>
      </Card>
    </div>
  )
};

let AssetForm = props => {
  const DATA_STATUS_OPTIONS = [
      { value: 'FULL_RECEIVING', label: 'Full Receiving' },
      { value: 'LARGE_MISSES', label: 'Large Misses' },
      { value: 'LITTLE_MISSES', label: 'Little Misses' },
      { value: 'NOT_RECEIVING', label: 'Not Receiving' }
    ];
  const ACTIVITY_STATUS_OPTIONS = [
      { value: 'ACTIVE', label: 'Active' },
      { value: 'OUT_OF_SERVICE', label: 'Out Of Service' },
      { value: 'DOWN', label: 'Down' },
    ];

  const {
    handleSubmit, submitting, initialValues,
    collections, asset_types, t,
  } = props;

  const hasAsset = initialValues && Object.keys(initialValues).length > 0;

  const ASSETS_TYPES_OPTIONS = filterAssetTypesOptionData(asset_types);
  const COLLECTION_OPTIONS = filterCollectionOptionData(collections);

  return (
    <Card className="a-height">
      <form  onSubmit={handleSubmit}>

        <CardHeader>
          <Row>
            <Col md={6}>
              { hasAsset && hasAsset > 0
                ? t('asset_management.create_update_asset.form_update_title')
                : t('asset_management.create_update_asset.form_create_title')
              }
            </Col>

            <Col md={6} className="text-right">
              <Button
                type="submit"
                className="icon rm-m-b"
                color="success"
              >
                <p>Save</p>
              </Button>
            </Col>
          </Row>
        </CardHeader>

        <CardBody>
          <Row>
            <Col xs="12" sm="5" className="form form--horizontal" >

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.name')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="asset_name"
                    component={renderField}
                    type="text"
                    placeholder="Asset Name"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.industry')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    name="industry"
                    component={renderField}
                    type="text"
                    placeholder="Industry"
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.data_status')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="data_status"
                    placeholder="Data Status"
                    type="select"
                    options={DATA_STATUS_OPTIONS}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.data_status')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="activity_status"
                    placeholder="Activity Status"
                    type="select"
                    options={ACTIVITY_STATUS_OPTIONS}
                  />
                </div>
              </div>

            </Col>
            <Col xs="12" sm="5" className="form form--horizontal">

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.asset_type')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="asset_type_name"
                    placeholder="Asset Type"
                    type="select"
                    options={ASSETS_TYPES_OPTIONS}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.collection')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderSelectField}
                    name="collection_id"
                    placeholder="Collection"
                    type="select"
                    options={COLLECTION_OPTIONS}
                  />
                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('asset_management.asset_label.health_status')}
                </span>
                <div className="form__form-group-field">
                  <Field
                    component={renderField}
                    name="health_status"
                    placeholder=""
                    type="text"
                  />
                </div>
              </div>

              <Field
                component={renderField}
                name="owner"
                placeholder="owner"
                type="hidden"
                value="4483"
              />

            </Col>
          </Row>

          <FieldArray name="details" component={e => renderParam(e, t)} />
        </CardBody>
      </form>
    </Card>
  );
};

function mapStateToProps(state, ownProps, context) {
  let { form_data } = ownProps;
  const newFormData = form_data && Object.keys(form_data).length > 0
    ? JSON.parse(JSON.stringify(form_data)) : {};

  const collections = state.collections;
  const asset_types = state.asset_types;

  let newDetails = [];
  if(newFormData.details && Object.keys(newFormData.details).length > 0) {
    for(let detailKey in newFormData.details) {
      newDetails = [...newDetails, {'key': detailKey, 'value': newFormData.details[detailKey]}];
    }
  }
  form_data = newFormData;
  form_data.details = newDetails;

  if (form_data && form_data.formType && form_data.formType === "clone") {
    delete form_data._id;
  }

  return { initialValues: form_data, collections, asset_types};
}

let AssetData = reduxForm({
  validate: validate,
  form: "AssetForm",
  enableReinitialize: true
})(AssetForm);

const selector = formValueSelector('AssetForm');

export default withTranslation('common') (connect(state => mapStateToProps,{})(AssetData));
